import React, { FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';

import formatFileSize from '../../helpers/formatFileSize';
import { useTranslation } from '../../i18n';

type AttachmentsDropzoneLimitationsProps = {
  maxSize?: number;
  allowedFileTypes?: string;
};

const AttachmentsDropzoneLimitations: FC<
  AttachmentsDropzoneLimitationsProps
> = ({ maxSize, allowedFileTypes }) => {
  const { t } = useTranslation();
  return (
    <Flex flexDirection="column" textAlign="center">
      <Text>{t('REFERENCES_HINT_FORMA')}</Text>
      {allowedFileTypes && (
        <Text>{t('ALLOWED_FILE_TYPES', { allowedFileTypes })}</Text>
      )}
      {maxSize && (
        <Text>{t('MAX_FILE_SIZE', { maxSize: formatFileSize(maxSize) })}</Text>
      )}
    </Flex>
  );
};

export default AttachmentsDropzoneLimitations;
